/* Restyles the product description at render time. His descriptions follow one formula:
   an origin line, prose, a numbered nutrients block, a cooking methods line, sometimes a
   *starred* stock notice. This reads the rendered text and rebuilds it as chips, prose,
   lists, a notice, and a collapsed nutrients panel. The content itself is untouched, and
   any description that does not parse cleanly is left exactly as it was. */
(function () {
  function lines(el) {
    var out = [];
    el.querySelectorAll('p, li, div, h1, h2, h3, h4, h5, h6').forEach(function (b) {
      if (b.querySelector('p, div, li')) return; // only leaf blocks
      b.innerText.split('\n').forEach(function (s) { s = s.trim(); if (s) out.push(s); });
    });
    if (!out.length) el.innerText.split('\n').forEach(function (s) { s = s.trim(); if (s) out.push(s); });
    return out;
  }

  function chip(txt, cls) {
    var s = document.createElement('span');
    s.className = 'dx-pd-chip' + (cls ? ' ' + cls : '');
    s.textContent = txt;
    return s;
  }

  function init() {
    var box = document.querySelector('.product__description');
    if (!box || box.dataset.dxStyled) return;
    if (box.querySelector('img, a, table, iframe')) return;  // rare rich description: leave it
    var ls = lines(box);
    if (!ls.length) return;

    var origin = null, farmed = null, pack = null, cooking = null;
    var notices = [], flow = [], nutri = [];
    var mode = '';

    ls.forEach(function (raw) {
      var line = raw.replace(/\s+/g, ' ').trim();
      var m;
      // *starred* stock and price notices become one amber note
      var star = line.match(/\*([^*]{6,})\*/);
      if (star) {
        notices.push(star[1].trim());
        line = line.replace(/\*[^*]{6,}\*/g, '').trim();
        if (!line) return;
      }
      if ((m = line.match(/^country of origin\s*:?\s*(.+)$/i))) {
        var v = m[1].trim();
        var kind = v.match(/\((wild[- ]?caught|farmed)\)/i);
        if (kind) { farmed = kind[1].toLowerCase().replace('-', ' '); v = v.replace(kind[0], '').trim(); }
        origin = v.replace(/[.,;]$/, '');
        mode = '';
        return;
      }
      if ((m = line.match(/^pack size\s*:?\s*(.+)$/i))) { pack = m[1].trim(); mode = ''; return; }
      if ((m = line.match(/^recommended cooking methods?\s*:?\s*(.+)$/i))) {
        cooking = m[1].split(/[,;]/).map(function (s) { return s.replace(/\betc\.?\b/i, '').replace(/[.]$/, '').trim(); })
          .filter(function (s) { return s && s.length < 26; });
        mode = '';
        return;
      }
      if (/^nutrients?\s*(&|and)\s*vitamins?/i.test(line)) { mode = 'nutri'; return; }
      var num = line.match(/^\d{1,2}\)\s*(.+)$/);
      if (mode === 'nutri') {
        if (num) { nutri.push(num[1].trim()); return; }
        if (nutri.length) { nutri[nutri.length - 1] += ' ' + line; return; }  // wrapped item
        mode = '';
      }
      if (num) {
        var last = flow[flow.length - 1];
        if (last && last.t === 'list') last.items.push(num[1].trim());
        else flow.push({ t: 'list', items: [num[1].trim()] });
        return;
      }
      flow.push({ t: 'p', text: line });
    });

    // only rebuild when the formula was actually recognised
    if (!origin && !cooking && !nutri.length && !notices.length) return;

    var frag = document.createDocumentFragment();

    notices.forEach(function (n) {
      var d = document.createElement('p');
      d.className = 'dx-pd-note';
      d.textContent = n.charAt(0) + n.slice(1).toLowerCase();
      frag.appendChild(d);
    });

    if (origin || farmed || pack) {
      var row = document.createElement('div');
      row.className = 'dx-pd-chips';
      if (origin) row.appendChild(chip(origin, 'dx-pd-chip--origin'));
      if (farmed) row.appendChild(chip(farmed, 'dx-pd-chip--kind'));
      if (pack) row.appendChild(chip('pack ' + pack, 'dx-pd-chip--kind'));
      frag.appendChild(row);
    }
    if (cooking && cooking.length) {
      var crow = document.createElement('div');
      crow.className = 'dx-pd-chips';
      var lbl = document.createElement('span');
      lbl.className = 'dx-pd-chips-lbl';
      lbl.textContent = 'Cooks well:';
      crow.appendChild(lbl);
      cooking.forEach(function (cM) { crow.appendChild(chip(cM)); });
      frag.appendChild(crow);
    }

    flow.forEach(function (b) {
      if (b.t === 'p') {
        var p = document.createElement('p');
        p.textContent = b.text;
        frag.appendChild(p);
      } else {
        var ul = document.createElement('ul');
        ul.className = 'dx-pd-list';
        b.items.forEach(function (it) { var li = document.createElement('li'); li.textContent = it; ul.appendChild(li); });
        frag.appendChild(ul);
      }
    });

    if (nutri.length) {
      var det = document.createElement('details');
      det.className = 'dx-pd-nutri';
      var sum = document.createElement('summary');
      sum.textContent = 'Nutrients and vitamins';
      var pl = document.createElement('span');
      pl.className = 'dx-pd-pl';
      pl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
      sum.appendChild(pl);
      det.appendChild(sum);
      var ul2 = document.createElement('ul');
      ul2.className = 'dx-pd-list';
      nutri.forEach(function (it) { var li = document.createElement('li'); li.textContent = it; ul2.appendChild(li); });
      det.appendChild(ul2);
      frag.appendChild(det);
    }

    box.textContent = '';
    box.appendChild(frag);
    box.dataset.dxStyled = '1';
    box.classList.add('dx-pd');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
